import { useEffect, useState } from 'react';
import { fetchDgGoods } from '../../api/admin';
import SearchField from '../global-components/searchField';
import X from '../../../assets/icons/new_icon/x.svg';
import DgModal from './DgModal';
import infoIcon from '../../assets/icons/new_icon/blue-infoicon.svg';
import PageSizeDropdown from '../global-components/pageSizeDropDown';
import NewPaginationContainer from '../global-components/new-pagination';
import PageToolbar from '../global-components/pageToolbar';
function DangerousGoods() {
  const [dgGoodsList, setDgGoodsList] = useState<any>();
  const [searchTerm, setSearchTerm] = useState('');
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState<number>(25);
  const pageSizeOptions: number[] = [25, 50, 75, 100, 125];
  const [loading, setLoading] = useState(false);

  const handleOpenInfoModal = () => {
    setShowInfoModal(true);
  };

  function fetchData(query?: string) {
    setLoading(true);

    let payload = {
      page: currentPage,
      pageSize: pageSize,
      search: query ? query : '',
    };
    fetchDgGoods(payload)
      .then((response) => {
        if (!response?.data?.is_error) {
          setLoading(false);

          setDgGoodsList(response?.data?.content);
        }
      })
      .catch((e) => {
        setLoading(false);
      });
  }
  useEffect(() => {
    fetchData();
  }, []);

  const handleSearchField = (query: string) => {
    fetchData(query);
    setCurrentPage(1);
  };

  const sliceData = () => {
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    return dgGoodsList?.slice(startIndex, endIndex);
  };

  // Filtered and paginated data to be displayed
  const paginatedData = sliceData();
  return (
    <div className='container-fluid mt-2 my-4'>
      <div className='row mb-5'>
        <div className='col-12'>
          <div className='card-body p-4'>
            <PageToolbar
              handleSearchField={handleSearchField}
              setSearchQuery={setSearchTerm}
              searchText={searchTerm}
            >
              <button
                className='btn btn-ubbe-secondary align-items-center '
                onClick={handleOpenInfoModal}
              >
                <span className='dgIcon'>
                  <svg
                    width='15'
                    height='16'
                    viewBox='0 0 15 16'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <g clip-path='url(#clip0_2273_63971)'>
                      <path
                        d='M7.51172 15.5C3.36947 15.5 0.0117188 12.1423 0.0117188 8C0.0117188 3.85775 3.36947 0.5 7.51172 0.5C11.654 0.5 15.0117 3.85775 15.0117 8C15.0117 12.1423 11.654 15.5 7.51172 15.5ZM6.98972 12.8495C7.46222 12.8495 7.98872 12.6335 8.63672 11.756L9.31997 10.841C9.33994 10.8143 9.35437 10.7838 9.3624 10.7514C9.37043 10.719 9.3719 10.6853 9.36673 10.6523C9.36156 10.6193 9.34985 10.5877 9.33229 10.5593C9.31473 10.5309 9.29167 10.5064 9.26447 10.487C9.20693 10.4464 9.1364 10.4285 9.06646 10.4368C8.99652 10.4451 8.93213 10.479 8.88572 10.532L7.77947 11.7913C7.75402 11.8202 7.71999 11.8402 7.68235 11.8485C7.64471 11.8567 7.60542 11.8527 7.57022 11.837C7.53605 11.822 7.50828 11.7954 7.49181 11.7619C7.47534 11.7284 7.47124 11.6902 7.48022 11.654L8.87372 6.0695C8.88912 6.00864 8.88896 5.94488 8.87326 5.88409C8.85756 5.8233 8.82682 5.76744 8.78386 5.72165C8.74091 5.67586 8.68713 5.64161 8.62747 5.62206C8.56781 5.6025 8.50419 5.59827 8.44247 5.60975L5.92997 6.0695C5.88057 6.07857 5.83481 6.10162 5.79812 6.13592C5.76143 6.17022 5.73534 6.21432 5.72297 6.263L5.65847 6.5135C5.65137 6.54124 5.65071 6.57024 5.65656 6.59827C5.6624 6.6263 5.67459 6.65262 5.69218 6.67521C5.70978 6.6978 5.73231 6.71607 5.75806 6.7286C5.78381 6.74113 5.81208 6.74759 5.84072 6.7475H7.13822L6.03122 11.189C5.99072 11.3645 5.92322 11.6615 5.92322 11.8775C5.92322 12.377 6.22022 12.8495 6.98972 12.8495ZM8.36222 4.9475C8.88872 4.9475 9.29372 4.637 9.40172 4.1645C9.42872 4.0565 9.44222 3.935 9.44222 3.854C9.44222 3.476 9.14522 3.125 8.59172 3.125C8.06522 3.125 7.66022 3.4355 7.55222 3.908C7.52716 4.00966 7.51357 4.11381 7.51172 4.2185C7.51172 4.5965 7.80872 4.9475 8.36222 4.9475Z'
                        fill='#251163'
                        className='request-quote-icon-path'
                      />
                    </g>
                    <defs>
                      <clipPath id='clip0_2273_63971'>
                        <rect
                          width='15'
                          height='15'
                          fill='white'
                          transform='translate(0 0.5)'
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </span>
                Information & Limitations
              </button>
              {showInfoModal && (
                <DgModal
                  onClose={() => {
                    setShowInfoModal(false);
                  }}
                />
              )}
            </PageToolbar>

            {/* <div className='row mb-4 mt-4'>
                <div className='col-sm-12 col-md-9'></div>
                <div className='col-sm-12 col-md-3'>
                  <SearchField
                    id={'search-field'}
                    placeHolder={'Search'}
                    className={'form-control ubbe-input w-100'}
                    handleSearchField={handleSearchField}
                    setSearchQuery={setSearchTerm}
                  />
                </div>
              </div> */}

            <table className='table ' id='dg_table'>
              <thead className='position-sticky top-0 ubbe-table-header'>
                <tr>
                  <th
                    scope='col'
                    className={`text-start align-middle ubbe-table-heading-text`}
                  >
                    UN
                  </th>
                  <th
                    scope='col'
                    style={{ width: '15%' }}
                    className={`text-start align-middle ubbe-table-heading-text`}
                  >
                    Shipping Name
                  </th>
                  <th
                    scope='col'
                    className={`text-start align-middle ubbe-table-heading-text`}
                  >
                    Classification
                  </th>
                  <th
                    scope='col'
                    className={`text-start align-middle ubbe-table-heading-text`}
                  >
                    Packing Group
                  </th>
                  <th
                    scope='col'
                    className={`text-start align-middle ubbe-table-heading-text`}
                  >
                    State
                  </th>
                  <th
                    scope='col'
                    className={`text-start align-middle ubbe-table-heading-text`}
                  >
                    Unit
                  </th>
                  <th
                    scope='col'
                    className={`text-start align-middle ubbe-table-heading-text`}
                  >
                    Gross Measure
                  </th>
                  <th
                    scope='col'
                    className={`text-start align-middle ubbe-table-heading-text`}
                  >
                    NEQ
                  </th>
                  <th
                    scope='col'
                    className={`text-start align-middle ubbe-table-heading-text`}
                  >
                    NOS
                  </th>
                </tr>
              </thead>
              <tbody id='dg_rows' className='legs'>
                {paginatedData && paginatedData.length > 0 ? (
                  paginatedData.map((item: any, key: any) => (
                    <tr key={key}>
                      <td className='align-middle '>{item?.un_number}</td>
                      <td className='align-middle '>
                        {item?.short_proper_shipping_name}
                      </td>
                      <td className='align-middle '>
                        {item?.classification?.classification_name}
                      </td>
                      <td className='align-middle '>
                        {item?.packing_group?.combined}
                      </td>
                      <td className='align-middle '>{item?.state_name}</td>
                      <td className='align-middle '>
                        {item?.unit_measure_name}
                      </td>
                      <td className='align-middle '>
                        {item?.is_gross_measure ? 'Yes' : 'No'}
                      </td>
                      <td className='align-middle '>
                        {item?.is_neq ? 'Yes' : 'No'}
                      </td>
                      <td className='align-middle '>
                        {item?.is_nos ? 'Yes' : 'No'}
                      </td>
                    </tr>
                  ))
                ) : loading ? (
                  <tr className='text-center'>
                    <td colSpan={9} className='align-middle '>
                      <div className='spinner-border' role='status'>
                        <span className='visually-hidden'>Loading...</span>
                      </div>
                    </td>
                  </tr>
                ) : (
                  <>
                    <tr style={{ border: 'none' }}>
                      {' '}
                      <td
                        colSpan={9}
                        className='text-center global-text align-middle '
                        style={{
                          color: ' #979797                       ',
                          border: 'none',
                        }}
                      >
                        Dangerous Goods not found! Please try again.
                      </td>
                    </tr>
                  </>
                )}
              </tbody>
            </table>

            {dgGoodsList && dgGoodsList?.length > 10 && (
              <div className='d-flex align-items-center justify-content-end gap-3'>
                <PageSizeDropdown
                  setPageSize={setPageSize}
                  pageSizeOptions={pageSizeOptions}
                  currentSize={pageSize}
                  setCurrentPage={setCurrentPage}
                />
                <NewPaginationContainer
                  totalItems={dgGoodsList?.length}
                  totalPages={Math.ceil(dgGoodsList?.length / pageSize)}
                  currentPage={currentPage}
                  pageSize={pageSize}
                  setCurrentPage={setCurrentPage}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default DangerousGoods;
